import { render } from "./vapplink.vue?vue&type=template&id=2ce1ab12"
import script from "./vapplink.vue?vue&type=script&lang=js"
export * from "./vapplink.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__